<div class="pbv-header">
    <a href="#" class="pbv-link">
        <span class="pbv-text">Powered by </span>
        <img class="pbv-logo" alt="Powered by VECMAP" src="assets/images/pbv-logo.png" />
    </a>
</div>

